export const CHART_COLORS = [
  "#0F172A", "#2563EB", "#7C3AED", "#DB2777", "#F59E0B",
  "#059669", "#DC2626", "#0EA5E9", "#4F46E5", "#B45309",
  "#9333EA", "#0284C7", "#CA8A04", "#65A30D", "#E11D48",
];

export function fmtUSD(n) {
  if (n === null || n === undefined || n === "" || Number.isNaN(Number(n))) return "—";
  n = Number(n);
  if (n === 0) return "$0";
  const abs = Math.abs(n);
  if (abs >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `$${(n / 1e3).toFixed(1)}K`;
  if (abs < 1) return `$${n.toFixed(4)}`;
  return `$${n.toLocaleString()}`;
}

export function fmtNum(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString();
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "—";
  }
}

export function relDays(s) {
  if (!s) return "";
  const d = new Date(s);
  const diff = Math.round((d - new Date()) / (1000 * 60 * 60 * 24));
  if (diff === 0) return "today";
  if (diff > 0) return `in ${diff}d`;
  return `${-diff}d ago`;
}

export function scoreTone(score) {
  if (score >= 80) return { text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200", bar: "#059669" };
  if (score >= 65) return { text: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200", bar: "#2563EB" };
  if (score >= 50) return { text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200", bar: "#F59E0B" };
  if (score >= 35) return { text: "text-orange-700", bg: "bg-orange-50", border: "border-orange-200", bar: "#EA580C" };
  return { text: "text-red-700", bg: "bg-red-50", border: "border-red-200", bar: "#DC2626" };
}

export const RISK_TONE = {
  Critical: { text: "text-red-700", bg: "bg-red-100", border: "border-red-300", dot: "#DC2626" },
  High: { text: "text-red-700", bg: "bg-red-50", border: "border-red-200", dot: "#EF4444" },
  Medium: { text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200", dot: "#F59E0B" },
  Low: { text: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200", dot: "#3B82F6" },
  Informational: { text: "text-slate-600", bg: "bg-slate-50", border: "border-slate-200", dot: "#94A3B8" },
  None: { text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200", dot: "#10B981" },
};

export const VERIF_TONE = {
  "Confirmed Fact": { text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200" },
  "Official Project Claim": { text: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200" },
  "Third-Party Report": { text: "text-indigo-700", bg: "bg-indigo-50", border: "border-indigo-200" },
  "AI Inference": { text: "text-violet-700", bg: "bg-violet-50", border: "border-violet-200" },
  "Unverified": { text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200" },
  "Conflicting Information": { text: "text-red-700", bg: "bg-red-50", border: "border-red-200" },
};

export function monogramColor(str) {
  const palette = ["#0F172A", "#1E3A8A", "#4338CA", "#6D28D9", "#9D174D", "#B45309", "#065F46", "#0C4A6E", "#7C2D12"];
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) % palette.length;
  return palette[h];
}
